export default "__VITE_ASSET__B78R7KT6__"